import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DCDCDC",
    color: "#000",
    padding: "0 0 0 10px",
    borderRight: "1px solid #F2F2F2",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function createData(name, calories, fat, carbs, protein, address) {
  return { name, calories, fat, carbs, protein, address };
}

const rows = [
  // createData("Frozen yoghurt", 159, 6.0, 24, 4.0, 5),
  // createData("Ice cream sandwich", 237, 9.0, 37, 4.3, 5),
  // createData("Eclair", 262, 16.0, 24, 6.0, 5),
  // createData("Cupcake", 305, 3.7, 67, 4.3, 5),
  // createData("Gingerbread", 356, 16.0, 49, 3.9, 5),
];

export default function DataTable() {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead sx={{ background: "" }}>
          <TableRow sx={{ height: 44 }}>
            <StyledTableCell align="left">SI No.</StyledTableCell>
            <StyledTableCell align="left">Name</StyledTableCell>
            <StyledTableCell align="left">Phone</StyledTableCell>
            <StyledTableCell align="left">Email</StyledTableCell>
            <StyledTableCell align="left">Date of Birth</StyledTableCell>
            <StyledTableCell align="left">Address</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="left">{row.calories}</TableCell>
              <TableCell align="left">{row.fat}</TableCell>
              <TableCell align="left">{row.carbs}</TableCell>
              <TableCell align="left">{row.protein}</TableCell>
              <TableCell align="left">{row.address}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
